export default class DocumentSchemaType {

  static WORKER = 1;
  static MACHINE = 2;
  static OUTSOURCE = 3;
  static WORK = 4;
  static MONTHLY = 5;
  static LINKED = 6;
  static LINKED_WORK_COMPANY = 61;
  static LINKED_COMPANY_COMPANY = 62;
  static LINKED_WORK_COMPANY_COMPANY = 63;

}


// WEBPACK FOOTER //
// ./src/app/shared/model/DocumentSchemaType.js